module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/btn_edit-4c1dde888fb46dbcbb428e02aaae12d7.png";